import {yupResolver} from "@hookform/resolvers/yup";
import React from "react";
import {FieldErrors, FormProvider, useForm} from "react-hook-form";
import * as Yup from "yup";

import {ContactsSelectField} from "@/components/form/fields/ContactsSelectField/ContactsSelectField.tsx";
import FormErrorAlerts from "@/components/form/FormErrorAlerts.tsx";
import {ServiceField} from "@/lib/constants/service.ts";
import {ServerErrors} from "@/lib/types/common.ts";
import {EditCheckContactsFormValues} from "@/pages/checks/list/actions/bulkSetContacts/BulkSetContactsModal.tsx";

export interface BulkSetContactsFormProps {
  formId: string;
  onSubmit: (data: EditCheckContactsFormValues) => void;
  onError?: (errors: FieldErrors<EditCheckContactsFormValues>, event?: React.BaseSyntheticEvent) => void;
  serverErrors?: ServerErrors;
}

export const BulkSetContactsForm = ({formId, onSubmit, onError, serverErrors}: BulkSetContactsFormProps) => {
  const validationSchema = Yup.object({
    contact_groups: Yup.array()
      .of(Yup.number().required())
      .min(1, "Please select at least one contact.")
      .required("Please select at least one contact."),
  });
  const methods = useForm<EditCheckContactsFormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      contact_groups: [],
    },
  });
  return (
    <FormProvider {...methods}>
      <form
        id={formId}
        onSubmit={(e) => {
          methods.handleSubmit(onSubmit, onError)(e);
        }}
      >
        {serverErrors?.contact_groups && <FormErrorAlerts errors={serverErrors?.contact_groups} />}
        <div className="row mb-4">
          <div className="col">Note: Existing contacts will be replaced with whatever you select below.</div>
        </div>
        <ContactsSelectField
          shouldClearErrors
          name={ServiceField.CONTACT_GROUPS}
          menuPortalTarget={
            (document.querySelector(`div.outlet-container > div.content-container`) as HTMLElement) ?? document.body
          }
          menuPosition={"fixed"}
        />
      </form>
    </FormProvider>
  );
};
